const route = [
  {
    path: '/hospital/group/goods', // mother -> 母婴，andrology -> 专科
    name: 'service/goods',
    component: () => import(/* webpackPrefetchPlaceHolder */ './index'),
    auth: false,
    exact: true,
    realAuth: false,
    title: '健康管理服务',
  },
  {
    path: '/hospital/group/detail', // mother -> 母婴，andrology -> 专科
    name: 'service/goods',
    component: () => import(/* webpackPrefetchPlaceHolder */ './detail'),
    auth: false,
    exact: true,
    realAuth: false,
    title: '众安互联网医院',
  },
  {
    path: '/hospital/group/confirm', // mother -> 母婴，andrology -> 专科
    name: 'service/goods',
    component: () => import(/* webpackPrefetchPlaceHolder */ './confirmOrder'),
    auth: true,
    exact: true,
    realAuth: false,
    title: '确认订单',
  },
  {
    path: '/hospital/group/rights', // mother -> 母婴，andrology -> 专科
    name: 'service/rights',
    component: () => import(/* webpackPrefetchPlaceHolder */ './rights'),
    auth: true,
    exact: true,
    realAuth: true,
    title: '健康服务',
  },
  {
    path: '/hospital/group/paysuccess', // mother -> 母婴，andrology -> 专科
    name: 'service/rights',
    component: () => import(/* webpackPrefetchPlaceHolder */ './paySuccess'),
    auth: true,
    exact: true,
    realAuth: false,
    title: '支付成功',
  },
];

export default route;
